import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useCompanyCommentsData } from '@/composables/useCompanyCommentsData';
    import CommentsSkeleton from '@/components/company-comments/CommentsSkeleton.vue';
    import CommentsMessage from '@/components/company-comments/CommentsMessage.vue';
    import { onMounted, watch, ref, nextTick } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsMessages',
  props: {
    companyId: {},
    commentCount: {}
  },
  setup(__props: any) {

    const props = __props;

    const { comments, isLoadingComments } = useCompanyCommentsData(props.companyId);

    const scrollContainer = ref<HTMLElement | null>(null);

    onMounted(() => {
        scrollToBottom();
    });

    watch(comments, async () => {
        await nextTick();
        scrollToBottom();
    });

    function scrollToBottom() {
        if (scrollContainer.value) {
            scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollContainer",
    ref: scrollContainer,
    class: "no-scrollbar flex h-full max-h-128 min-h-32 w-full flex-col gap-7 overflow-y-auto pb-5"
  }, [
    (_unref(isLoadingComments) && _ctx.commentCount > 0)
      ? (_openBlock(), _createBlock(CommentsSkeleton, { key: 0 }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(comments), (comment) => {
          return (_openBlock(), _createBlock(CommentsMessage, {
            key: comment.id,
            comment: comment
          }, null, 8, ["comment"]))
        }), 128))
  ], 512))
}
}

})